import { observer } from "mobx-react-lite";

import { useNodeThemeColors } from "@/components/expression/theme/useNodeTheme";
import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { twMerge } from "@/utils/twMerge";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";

type Props = {
  node: DecoratorNodeModel;
  position?: "over" | "under";
};

export const Bar = observer(function Bar({ node, position = "over" }: Props) {
  const { parent: symbolNode } = node;

  const { view, size } = useNodeStyle();
  const theme = useNodeThemeColors(symbolNode?.parent);

  const isTextView = view === "text";
  const smallerSize = size === "xs" || size === "xxs";

  return (
    <div
      className={twMerge(
        "absolute -left-[1px] -right-[1px] h-[1px] bg-document-text rounded-8",

        position === "over" && "top-0",
        position === "under" && "bottom-0",

        (isTextView || smallerSize) && "left-0 right-0",

        position === "over" && isTextView && smallerSize && "top-[0.09rem]",
        position === "over" && isTextView && size === "xxxs" && "-top-[0.08rem]",

        theme?.symbol && `bg-${theme.symbol.light} dark:bg-${theme.symbol.dark}`,
      )}
    />
  );
});
